import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
    standalone: true,
    template: ''
})
export class RedirectToPageComponent implements OnInit {
    constructor(private router: Router) {}

    ngOnInit(): void {
        this.router.navigate(['/performance']);
    }
}
